export class UltimoEstado {
    id:          string;
    fechaHora:   string;
    estado:      number;
    responsable: string;
}